module.exports = __webpack_public_path__ + "static/media/480.835c9ee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-flowers/light/480.png
// module id = 2068
// module chunks = 2